import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "maintenance-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_ctx.maintenanceStore.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_alert, {
          type: _ctx.alertType,
          title: _ctx.text,
          closable: _ctx.closable,
          "show-icon": "",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.maintenanceStore.dismiss()))
        }, null, 8, ["type", "title", "closable"])
      ]))
    : _createCommentVNode("", true)
}